{
    "Accessibility menu": "Menu Trợ Năng",
    "Close": "Đóng",
    "Content adjustments": "Điều Chỉnh Nội Dung",
    "Navigation adjustments": "Điều Chỉnh Điều Hướng",
    "Text Align": "Text Align",
    "Align Left": "Căn Trái",
    "Align Center": "Align Center",
    "Align Right": "Align Right",
    "Adjust Font Size": "Điều Chỉnh Cỡ Chữ",
    "Highlight Title": "Đánh Dấu Tiêu Đề",
    "Highlight Links": "Đánh Dấu Liên Kết",
    "Readable Font": "Phông Chữ Dễ Đọc",
    "Colour adjustments": "Điều Chỉnh Màu Sắc",
    "Dark Contrast": "Tương Phản Tối",
    "Light Contrast": "Tương Phản Sáng",
    "High Contrast": "Tương Phản Cao",
    "High Saturation": "Bão Hòa Cao",
    "Low Saturation": "Bão Hòa Thấp",
    "Monochrome": "Đơn Sắc",
    "Tools": "Công Cụ",
    "Reading Guide": "Hướng Dẫn Đọc",
    "Big Cursor": "Con Trỏ Lớn",
    "Increase Font Size": "Tăng Cỡ Chữ",
    "Decrease Font Size": "Giảm Cỡ Chữ",
    "Letter Spacing": "Khoảng Cách Chữ",
    "Line Height": "Chiều Cao Dòng",
    "Font Weight": "Độ Đậm Chữ",
    "Dyslexia Font": "Phông Chữ Cho Chứng Khó Đọc",
    "Language": "Ngôn Ngữ",
    "Accessibility widget": "Mở Menu Trợ Năng",
    "Accessibility Profiles": "Hồ Sơ Trợ Năng",
    "Cognitive Disability": "Khuyết Tật Nhận Thức",
    "Seizure Safe": "An Toàn Cho Động Kinh",
    "Accessibility statement": "Tuyên Bố Trợ Năng",
    "ADHD": "ADHD",
    "Low Vision": "Low Vision",
    "Pause Animations": "Dừng Hoạt Ảnh",
    "Animation paused": "Đã tạm dừng ảnh động",
    "Reset all settings": "Đặt lại cài đặt",
    "Shortcut:": "Shortcut:",
    "Epilepsy Safe Mode": "Epilepsy Safe Mode",
    "Mute sounds": "Mute sounds",
    "Page read": "Page read",
    "Page read controls": "Page read controls",
    "Pause": "Pause",
    "Resume": "Resume",
    "Stop": "Stop",
    "Settings": "Settings",
    "Speed": "Speed",
    "Voice": "Voice"
}
